import { render, staticRenderFns } from "./TextWidget.vue?vue&type=template&id=45f5a33a&scoped=true"
import script from "./TextWidget.vue?vue&type=script&lang=js"
export * from "./TextWidget.vue?vue&type=script&lang=js"
import style0 from "./TextWidget.vue?vue&type=style&index=0&id=45f5a33a&prod&scoped=true&lang=css"
import style1 from "./TextWidget.vue?vue&type=style&index=1&id=45f5a33a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f5a33a",
  null
  
)

export default component.exports